import { render, staticRenderFns } from "./UndoTransfer.vue?vue&type=template&id=6f6a455e&"
import script from "./UndoTransfer.vue?vue&type=script&lang=js&"
export * from "./UndoTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UndoTransfer.vue"
export default component.exports